<template>
  <div id="App">
    <van-nav-bar
      :title="team.Name"
      :left-text="showReturn ? '返回' : ''"
      :left-arrow="showReturn"
      @click-left="onClickLeft"
      :right-text="showAdd ? '添加工人' : ''"
      @click-right="onClickRight"
    />
    <van-list
      style="margin-top: -15px"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad()"
      ><van-divider />
      <van-cell
        v-for="item in list"
        :key="item.CODE"
        :title="item.NAME"
        :label="item.LOG"
        is-link
        size="large"
        @click="onClickCell(item)"
      >
        <van-tag :type="item.TYPE" class="custom-title" size="large">{{
          item.STATUS
        }}</van-tag>
      </van-cell>
    </van-list>
  </div>
</template>

<style>
.custom-title {
  margin-right: 4px;
  vertical-align: right;
}
</style>

<script>
import { mapState } from "vuex";
import { Dialog } from "vant";
export default {
  data() {
    return {
      list: [],
      showReturn: true,
      showAdd: true,
      loading: false,
      finished: false,
      team: {
        Code: "",
        Name: "",
        Pro: {
          Code: "",
          Name: ""
        }
      }
    };
  },
  computed: {
    ...mapState(["userInfo", "tempQuery"])
  },
  methods: {
    onClickRight() {
      var that = this;
      that.$store.commit("setTempQuery", {
        Code: getGuid(),
        Name: "",
        Team: {
          Code: that.team.Code,
          Name: that.team.Name,
          Pro: {
            Code: that.team.Pro.Code,
            Name: that.team.Pro.Name
          }
        }
      });
      that.$router.push({
        path: "/WorkerInfo",
        name: "WorkerInfo"
      });
    },
    onClickLeft() {
      var that = this;
      that.$router.push({
        path: "/SelWorkerTeam",
        name: "SelWorkerTeam"
      });
    },
    onClickCell(key) {
      var that = this;
      that.$store.commit("setTempQuery", {
        Code: key.CODE,
        Name: key.NAME,
        Team: {
          Code: that.team.Code,
          Name: that.team.Name,
          Pro: {
            Code: that.team.Pro.Code,
            Name: that.team.Pro.Name
          }
        }
      });
      that.$router.push({
        path: "/WorkerInfo",
        name: "WorkerInfo"
      });
    },
    onLoad() {
      this.loading = true;
      var that = this;
      that.team = that.tempQuery;
      that.$store.commit("setTempQuery", {
        Code: that.team.Pro.Code,
        Name: that.team.Pro.Name
      });
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatWorkerList",
            Params: [
              that.userInfo.userCardID,
              that.team.Code,
              that.userInfo.loginType,
              "1970-01-01",
              "0",
              "1"
            ]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.list = response.data.Table1;
            that.finished = true;
          } else {
            Dialog({ message: response.data.msg });
            that.finished = true;
          }
        })
        .catch(error => {
          window.console.log(error);
          //弹出失败提醒
          Dialog({ message: error.message });
          that.finished = true;
        });
    }
  }
};

function getGuid() {
  var guid = "";
  for (var i = 1; i <= 32; i++) {
    var flag = Math.floor(Math.random() * 10);
    if (flag % 2 == 0) {
      //全大写
      var n = Math.floor(flag * 2.4) + 65;
      //全小写
      // var n = Math.floor(flag*2.4) + 97;
      n = String.fromCharCode(n);
      guid += n;
    } else {
      guid += flag;
    }
    if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
  }
  return guid;
}
</script>
